export default function UnsafeMarkdown(props: { content: string }) {
  return (
    <div
      style={{ display: "inline" }}
      dangerouslySetInnerHTML={{ __html: props.content }}
    />
  );
}
